import { MakeItRightSection, MakeItMagicSection, MakeItWorkSection } from '../Sections';

export const RenderModules = ({
  selectedMenuItem,
  handleActiveMenuItem,
}: {
  selectedMenuItem: string;
  handleActiveMenuItem: (item?: string) => void;
}): JSX.Element => {
  switch (selectedMenuItem) {
    case 'make-it-right':
      return <MakeItRightSection onClick={handleActiveMenuItem} />;
    case 'make-it-magic':
      return <MakeItMagicSection onClick={handleActiveMenuItem} />;
    case 'make-it-work':
      return <MakeItWorkSection onClick={handleActiveMenuItem} />;
  }
  return <></>;
};
